export default __webpack_public_path__ + "static/media/Nuleep-Text.05694032.svg";